"use client";

import { useSyncExternalStore } from "react";

// Небольшие наборы slug-ов в localStorage: избранное и сравнение. Общие для всех дизайнов.
function createSet(key: string, limit = 99) {
  let items: string[] = [];
  let loaded = false;
  const listeners = new Set<() => void>();
  const load = () => {
    if (loaded || typeof window === "undefined") return;
    loaded = true;
    try {
      const saved = JSON.parse(localStorage.getItem(key) || "[]");
      if (Array.isArray(saved)) items = saved.filter((x) => typeof x === "string").slice(-limit);
    } catch {
      /* без хранилища — до перезагрузки */
    }
  };
  const emit = (next: string[]) => {
    items = next;
    try {
      localStorage.setItem(key, JSON.stringify(items));
    } catch {
      /* см. выше */
    }
    listeners.forEach((l) => l());
  };
  const EMPTY: string[] = [];
  return {
    toggle(slug: string) {
      load();
      emit(items.includes(slug) ? items.filter((s) => s !== slug) : [...items, slug].slice(-limit));
    },
    clear() {
      emit([]);
    },
    use() {
      return useSyncExternalStore(
        (fn) => {
          load();
          listeners.add(fn);
          fn();
          return () => listeners.delete(fn);
        },
        () => items,
        () => EMPTY
      );
    },
  };
}

export const favs = createSet("nii-favs");
export const compare = createSet("nii-compare", 4);
